import { Pica } from "pica"
import { BaseImageResizer } from "./ImageResizeService.types"

export class PicaImageResizer extends BaseImageResizer {
  constructor(private picaInstance: Pica = new Pica()) {
    super()
  }

  async resize(file: File, options: ImageResizeOptions, image?: HTMLImageElement): Promise<File | undefined> {
    const blob = await this.resizeImage(image!, options)
    return this.toFile(blob, file, options.type)
  }

  async resizeImage(image: HTMLImageElement, options: ImageResizeOptions): Promise<Blob> {
    if (!image) throw new Error("Image element is required")

    const { width, height, type } = options

    // Resize using pica
    const target = document.createElement("canvas")
    target.width = width
    target.height = height

    await this.picaInstance.resize(image, target)

    // Convert canvas to blob/file
    const blob = await this.picaInstance.toBlob(target, type)
    return blob
  }
}
